<template>
  <div class="articledetail">
    <Headinfo :info="info" @getqr="showqrcode" />
    <div class="articletitle" style="font-weight: 700">
      {{ detail.title }}
    </div>
    <div class="artnum">
      <div class="btn">{{ detail.categoryName }}</div>
      <div style="color: #999fa4" class="f12 flex aic">
        <van-icon name="browsing-history" />
        <span class="ml-5">{{ detail.numbers }}</span>
      </div>
    </div>
    <div class="ql-snow">
      <div class="ql-editor" v-html="detail.content"  @click="imageEnlargement"></div>
      <van-divider class="ml-15 mr17" />
    </div>
    <div class="tar f12 cl99 mr17">来源：{{ detail.source }}</div>
    <div class="declare">
      【免责声明】所载内容处于学习、交流之目的，除内容来源“中联信保险”外内容，均来源互联网、微信公众号等公开渠道。若有来源标注错误或侵犯了您的合法权益，请与本站联系，我们将及时更正、删除，谢谢。
    </div>
    <Headinfo :info="info" @getqr="showqrcode" />
    <div class="bottombar pl-20 pr-15 jc-sb aic">
      <div @click="showqrcode">
        <img src="../../assets/img/card/weixin1.png" alt="" />
        <p class="f10 cl99">加微信咨询</p>
      </div>
      <div class="btnshare" @click="share">分享转发</div>
    </div>
    <van-overlay :show="shareshow" @click="shareshow = false">
      <div class="wrapper">
        <img src="../../assets/img/card/tips.jpg" class="shareimg" />
      </div>
    </van-overlay>
    <van-dialog v-model="qrcodeshow" title="长按识别微信二维码" width="260px">
      <img :src="info.qrCodeUrl" class="qrcode" />
    </van-dialog>
  </div>
</template>
<script>
import Headinfo from "./compontent/headinfo";
import { customerexist } from "@/api/clients";
import { userinfo, wxSocial, readRecord, getJsApiTicket } from "@/api/users";
import { articledetail } from "@/api/article";
import { getToken } from "@/utils/auth";
import Vue from "vue";
import { Overlay } from "vant";
import wx from "weixin-js-sdk";
import { ImagePreview } from 'vant';
import {  getImgSrc } from "../../utils/index";
import $ from "jquery";
Vue.use(Overlay);
export default {
  components: {
    Headinfo,
  },
  data() {
    return {
      userId: "", //用户id
      articleId: "", //文章id
      detail: "", //文章详情
      info: "", //用户信息
      startTime: 0, //进入页面时间
      customerId: "",
      _beforeUnload_time: "",
      shareshow: false,
      qrcodeshow: false,
      isAndroid: "",
      id: "",
      timer: "",
      imglist:[]
    };
  },
  methods: {
    getdetail() {
      // window.removeEventListener("pagehide",this.unloadHandler);
      articledetail(this.articleId).then((res) => {
        console.log(res);
        this.detail = res;
        this.imglist=getImgSrc(res.content)
        this.getwx();
      });
    },
    getinfo() {
      userinfo(this.userId).then((res) => {
        console.log(res);
        this.info = res;
      });
    },
    checkAuthor() {
      setTimeout(()=>{
        if(!this.customerId && !getToken()){
           WeixinJSBridge.call('closeWindow');
           document.addEventListener('WeixinJSBridgeReady', function(){ WeixinJSBridge.call('closeWindow'); }, false)
        }
      },3000)
      this.author();
    },
    author() {
      wxSocial({ requestUrl: this.$route.fullPath })
        .then((res) => {
          window.location.href = res;
          // window.location.href='www.baidu.com'
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    share() {
      this.shareshow = true;
    },
    addrecord() {
      if (!this.customerId || this.customerId == "null" || getToken()) return;

      let time = new Date() * 1;
      let data = {
        customerId: this.customerId,
        articleId: this.articleId,
        duration: time - this.startTime,
        userId: this.userId,
        type: "article",
        enterTime: this.startTime,
        leaveTime: time,
        id: this.id,
      };
      this.startTime = time;
      readRecord(data)
        .then((res) => {
          this.id = res.id;
          if (res.duration > 600000) {
            clearInterval(this.timer);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    unloadHandler(e) {
      this.addrecord();
    },
    showqrcode() {
      if (this.info.qrCodeUrl) {
        this.qrcodeshow = true;
      } else {
        this.Toast("该用户还没有二维码");
      }
    },
    getwx() {
      let that = this;
      const link = window.location.href.split("?")[0];
      // if (link !== window.location.href) {
      // 	window.location.href = link;
      // } //为了兼容iOS系统，否则有可能地址取值出现错误
      const url = window.location.href.split("#")[0];
      getJsApiTicket({
        link: url,
      }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式
          appId: res.body.appid, // 必填，公众号的唯一标识
          timestamp: res.body.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
          signature: res.body.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData", //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            "updateTimelineShareData", //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          ], // 必填，需要使用的JS接口列表
        });
      });
      wx.ready(function () {
        that.wxShareTimeline();
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      });
      wx.error((res) => {
        console.warn("微信注册", res);
        // if(res.errMsg!='config:ok'){
        //   that.getwx()
        // }
      });
    },
    wxShareTimeline() {
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容

      wx.updateAppMessageShareData({
        title: this.detail.title, // 分享标题
        desc: this.detail.source, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.detail.coverImgUrl, // 分享图标
        success: () => {
          console.log(1132);
        },
      });
      wx.updateTimelineShareData({
        title: this.detail.title, // 分享标题
        desc: this.detail.source, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.detail.coverImgUrl, // 分享图标
        success: () => {},
      });
    },
    setTimer() {
      if (this.customerId == "null" || getToken()) return;
      this.addrecord();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.addrecord();
        }, 60000);
      } else {
        this.timer = setInterval(() => {
          this.addrecord();
        }, 60000);
      }
    },
    //  放大富文本里的图片
    imageEnlargement(e) {
      let a=this.imglist.findIndex((item)=>
        item.split('//')[1]==e.target.currentSrc.split('//')[1])
      let startPosition=a!=-1?a:0
      console.log(startPosition,a)
      if (e.target.nodeName == "IMG") {
        //判断点击富文本内容为img图片
        ImagePreview({
          images: this.imglist, //获取当前图片src
          showIndex: false,
          loop: true,
          startPosition
        });
      }
    },
  },

  mounted() {
    let { userId, articleId, customerId } = this.$route.query;

    if (!customerId) {
      customerId = localStorage.getItem("customerId");
    } else {
      localStorage.setItem("customerId", customerId);
    }
    this.userId = userId;
    this.articleId = articleId;
    this.customerId = customerId;
    this.startTime = new Date() * 1;
    if (!customerId && !getToken()) {
      this.checkAuthor();

    } else if (customerId == "null" && !getToken()) {
      this.$router.push({ path: "/login" });
    } else {
      if (customerId != "null" && !getToken()) {
        customerexist(customerId).then((res) => {
          if (res == false) {
            this.checkAuthor();
          } else {
            this.getdetail();
            this.getinfo();
            this.setTimer();
          }
        });
      } else {
        this.getdetail();
        this.getinfo();
        this.setTimer();
      }
    }
  },
  beforeDestroy() {
    if (getToken()) {
      sessionStorage.removeItem("url");
    }
    clearInterval(this.timer);
    // window.removeEventListener("pagehide", this.unloadHandler);
    this.addrecord();
  },
};
</script>
<style lang="less" scoped>
.articledetail {
  width: 100%;
  background: #fff;
  min-height: 100vh;
  padding-bottom: 90px;
  .articletitle {
    width: 335px;
    // height: 124px;
    color: rgba(16, 16, 16, 100);
    font-size: 21px;
    text-align: left;
    line-height: 31px;
    font-family: SourceHanSansSC-bold;
    margin: 17px auto;
    font-weight: blod;
  }
  .artnum {
    width: 335px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    .btn {
      width: 51px;
      // height: 18px;
      line-height: 18px;
      border-radius: 9px;
      color: rgba(93, 199, 185, 100);
      font-size: 9px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(93, 199, 185, 100);
    }
  }
  .bottombar {
    width: 100%;
    height: 71px;

    background-color: rgba(255, 255, 255, 100);
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 100);
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    img {
      width: 29px;
      height: 29px;
    }
    .btnshare {
      width: 275px;
      height: 40px;
      line-height: 40px;
      border-radius: 200px;
      background-color: rgba(49, 213, 191, 100);
      color: rgba(255, 255, 255, 100);
      font-size: 16px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(255, 255, 255, 100);
    }
  }
  .declare {
    width: 341px;
    color: rgba(16, 16, 16, 100);
    font-size: 12px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    margin: 26px auto;
    line-height: 20px;
    border-radius: 10px;
    background-color: rgba(249, 250, 254, 100);
    padding: 10px;
    box-sizing: border-box;
  }
  .mr17 {
    margin-right: 17px;
  }
  .shareimg {
    width: 50%;
    float: right;
    margin-right: 10px;
  }
  .qrcode {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    display: block;
  }
}
</style>